export default __webpack_public_path__ + "navigation-examples-custom-server-960-d9a945917704de63b0bc903e7570859f.webp";